import type { TestContext, TestFunction } from 'yup';

import { parseFromHumanToIsoDate } from 'shared/lib/dates';

export const isCorrectLastWorkExperienceMonth: TestFunction<string> = (value, testContext) => {
  const context = testContext.parent ? testContext : (testContext.options.context as TestContext);
  const valueDate = parseFromHumanToIsoDate(value, 'MM.yyyy');

  if (!valueDate) {
    return context.createError({
      path: context.path,
      message: 'Некорректное значение',
    });
  }

  const currentDate = new Date();
  const minDate = new Date(1971, 0, 1);

  const isNotInFuture = currentDate >= valueDate;
  const isAfterMinDate = valueDate >= minDate;

  if (!isNotInFuture || !isAfterMinDate) {
    return context.createError({
      path: context.path,
      message: 'Некорректное значение',
    });
  }

  return true;
};
